import { useI18n } from '#/hooks/useI18n';
import { Document } from '#/models';
import { FC } from 'react';
import { Download, PrimaryButton, TertiaryButton } from '@zazume/zzm-base';
import { PdfViewer } from './PdfViewer';
import { DocumentModalInfo } from './documentModalInfo/DocumentModalInfo';
import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { useDownloadDocument } from '#/hooks/documents/useDownloadDocument';
import { useGet } from '#/hooks';
import { API } from '#/lib/network/API';
import { DocumentWithControlsContainer } from './DocumentWithControlsContainer';

interface RenderInvoiceDocumentTabContentProps {
  document: Document;
  close: () => void;
  onNextClick?: (id: string) => void;
  onPreviousClick?: (id: string) => void;
  hasNext?: boolean;
  hasPrevious?: boolean;
}

const Container = styled.div(({ theme }) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing.s10};

  ${theme.mq.tablet} {
    flex-direction: row;
  }
`);

const Footer = styled.div(({ theme }) => css`
  margin: ${theme.spacing.s10} ${theme.spacing.s0};
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: ${theme.spacing.s8};
`);

export const RenderInvoiceDocumentTabContent: FC<RenderInvoiceDocumentTabContentProps> = ({ document, close, onNextClick, onPreviousClick, hasNext, hasPrevious }) => {
  const { t } = useI18n();
  const { download } = useDownloadDocument(document._id);
  const { data, isLoading: isLoadingData } = useGet(['document_url', document._id], API.documents.getURL(document._id));

  return (
    <>
      <Container>
        <DocumentWithControlsContainer documentId={document._id} onNextClick={onNextClick} onPreviousClick={onPreviousClick} hasNext={hasNext} hasPrevious={hasPrevious}>
          {!isLoadingData ? <PdfViewer document={data}/> : null}
        </DocumentWithControlsContainer>
        <DocumentModalInfo document={document}/>
      </Container>
      <Footer>
        <TertiaryButton onClick={close}>
          {t('general.close')}
        </TertiaryButton>
        <PrimaryButton onClick={download}>
          <Download/> {t('documentsModals.downloadDocument')}
        </PrimaryButton>
      </Footer>
    </>
  );
};
